// extracted by mini-css-extract-plugin
export default {"root":"TextArea_root__lE+YF","label":"TextArea_label__MRNY5","errorMessage":"TextArea_errorMessage__869ay"};